/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiOrder, LockElement, LockedContextDto, UpdateStagingStatusRequest } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of OrdersController.
 */
export class OrdersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /orders
     */
    public addWithStaging(appObjectIn: ApiOrder): Promise<Result<ApiOrder>> {
        return this.http.post<Result<ApiOrder>, ApiOrder>('/orders', appObjectIn);
    }

    /**
     * Calls PUT /orders/{primaryId}
     */
    public updateWithStaging(appObjectIn: ApiOrder, primaryId: string): Promise<Result<ApiOrder>> {
        return this.http.put<Result<ApiOrder>, ApiOrder>(`/orders/${primaryId}`, appObjectIn);
    }

    /**
     * Calls PATCH /orders
     */
    public putRangeWithStaging(apiObjects: ApiOrder[]): Promise<Result<ApiOrder[]>> {
        return this.http.patch<Result<ApiOrder[]>, ApiOrder[]>('/orders', apiObjects);
    }

    /**
     * Calls PATCH /orders/staging_status
     */
    public updateStagingStatus(request: UpdateStagingStatusRequest): Promise<Result<boolean>> {
        return this.http.patch<Result<boolean>, UpdateStagingStatusRequest>('/orders/staging_status', request);
    }

    /**
     * Calls POST /orders:prefill
     */
    public createPrefilled(): Promise<Result<ApiOrder>> {
        return this.http.post<Result<ApiOrder>, undefined>('/orders:prefill', undefined);
    }

    /**
     * Calls POST /orders/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiOrder>>> {
        return this.http.post<Result<LockedContextDto<ApiOrder>>, undefined>(`/orders/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /orders/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiOrder>> {
        return this.http.post<Result<ApiOrder>, undefined>(`/orders/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /orders/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiOrder[]>> {
        return this.http.post<Result<ApiOrder[]>, string[]>('/orders/locks', ids);
    }

    /**
     * Calls POST /orders/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/orders/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /orders/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/orders/${primaryId}/locks`);
    }

    /**
     * Calls GET /orders/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiOrder>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiOrder>>(`/orders/${primaryId}`, query);
    }

    /**
     * Calls DELETE /orders/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/orders/${primaryId}`);
    }

    /**
     * Calls POST /orders:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiOrder>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiOrder>>, ListRequestWithIds>('/orders:batch', listRequest, query);
    }

    /**
     * Calls POST /orders:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiOrder>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiOrder>>, ListRequest>('/orders:query', listRequest, query);
    }

    /**
     * Calls GET /orders:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiOrder>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiOrder>>>('/orders:query', query);
    }
}
